module.exports = __webpack_public_path__ + "img/2123.d5ae0602.gif";